import axios from "../axios";
import { ANALYSTS_STATS_URI } from "../constants/uri";
import { responseHandler, errorHandler } from "../utils/handlers";

export const getDailyByAnalyst = () => {
  return axios
    .get(`${ANALYSTS_STATS_URI}/daily`)
    .then(responseHandler)
    .catch(errorHandler);
};

export const getAppsReceivedAndClosed = () => {
  return axios
    .get(`${ANALYSTS_STATS_URI}/apps_received_and_closed`)
    .then(responseHandler)
    .catch(errorHandler);
};

export const getPendingMessagesCount = () => {
  return axios
    .get(`${ANALYSTS_STATS_URI}/pending_messages_count`)
    .then(responseHandler)
    .catch(errorHandler);
};

export const getKickbacksByDay = () => {
  return axios
    .get(`${ANALYSTS_STATS_URI}/work_week_kickbacks`)
    .then(responseHandler)
    .catch(errorHandler);
};

export const getWeeklyStats = () => {
  return axios
    .get(`${ANALYSTS_STATS_URI}/weekly_total`)
    .then(responseHandler)
    .catch(errorHandler);
};

export const getTodaysStats = () => {
  return axios
    .get(`${ANALYSTS_STATS_URI}/today`)
    .then(responseHandler)
    .catch(errorHandler);
};


export const getWeeklyStatsByAnalyst = () => {
  return axios
    .get(`${ANALYSTS_STATS_URI}/weekly`)
    .then(responseHandler)
    .catch(errorHandler);
};
